
enum CompanyHotelSettingsCalendarDayPopupTriggerType {
	ON_CLICK = 'ON_CLICK',
	ON_HOVER = 'ON_HOVER'
}

export default CompanyHotelSettingsCalendarDayPopupTriggerType;